import React from "react";
import ReactDOM from "react-dom";
import RestaurantsMapBrands from "./containers/RestaurantsMapBrands";
import {isEmpty} from "lodash";

export const initRestaurantsMapBrands = className => {
  let elements = document.querySelectorAll(`.${className}`);
  if (!isEmpty(elements)) {
    for (let element of elements) {
      ReactDOM.render(<RestaurantsMapBrands />, element);
    }
  }
};
